// Auto-generated by scripts/build-atlas.ts — do not edit
import type { AtlasEntry } from '@/types/atlas'

export const atlasGeneratedAt = "2026-08-10T18:32:21Z"

export const atlasEntries: AtlasEntry[] = [
  {
    "slug": "instacart",
    "name": "Instacart",
    "site_url": "https://www.instacart.com/",
    "domains": [
      "instacart.com"
    ],
    "description": "Instacart mapped signed in — storefront, aisle, product, in-store search and the 404, plus the GraphQL operations behind them.",
    "categories": [
      "commerce"
    ],
    "author": "chiplay",
    "created": "2026-08-08",
    "updated": "2026-08-10",
    "last_verified": "2026-08-08",
    "cli_version": "0.19.0",
    "spec_version": 1,
    "method": "browser",
    "auth": "personal-account",
    "stats": {
      "views": 5,
      "components": 31,
      "requests": 8,
      "properties": 10,
      "memory": 27
    },
    "per_view": [
      {
        "name": "Storefront",
        "route": "/store/:retailerSlug/storefront",
        "components": 4,
        "requests": 0
      },
      {
        "name": "Collection",
        "route": "/store/:retailerSlug/collections/:collectionSlug",
        "components": 3,
        "requests": 0
      },
      {
        "name": "SearchResults",
        "route": "/store/:retailerSlug/s",
        "components": 6,
        "requests": 1
      },
      {
        "name": "ProductDetail",
        "route": "/products/:productSlug",
        "components": 4,
        "requests": 1
      },
      {
        "name": "NotFound",
        "route": "/**",
        "components": 1,
        "requests": 0
      }
    ],
    "screenshots": [
      "screenshots/01-storefront.jpg",
      "screenshots/02-in-store-search.jpg"
    ],
    "files": [
      ".sightmap/config.yaml",
      ".sightmap/shared.yaml",
      ".sightmap/storefront.yaml"
    ],
    "commit": "9e52260a80a6697882b94669e240f0067d332319",
    "screenshotUrls": [
      "/atlas/screenshots/instacart/01-storefront.jpg",
      "/atlas/screenshots/instacart/02-in-store-search.jpg"
    ],
    "bodyHtml": "<h2>Instacart</h2>\n<p>Five views — a retailer storefront, an aisle, a product, in-store search, and\nthe 404. 31 components, 8 requests.</p>\n<h3>Why the map matters</h3>\n<p>The storefront never finishes loading. Skeleton placeholders keep mounting and\nreal items don&#39;t, so an agent that reads it comes away with a handful of\nproducts and no signal that it is looking at a fraction of the shelf. The map\nsays so, and says to read items from an aisle or a search instead.</p>\n<p>Underneath, everything is one <code>/graphql</code> endpoint — but the operation name is in\nthe query string, so a network log is filterable without parsing a single body.</p>\n<h3>Try it</h3>\n<pre><code class=\"language-bash\">sightmap atlas add instacart\n</code></pre>\n<p>Sign in and pick a retailer first; nothing renders without a delivery address.</p>\n<h3>What bites</h3>\n<ul>\n<li><strong>The storefront never resolves.</strong> Placeholders outnumber items and the gap\nwidens the longer you wait. Aisle, product and search all resolve normally.</li>\n<li><strong>Scripted scrolling mounts nothing.</strong> <code>window.scrollTo</code> moves the viewport;\nonly a real scroll event loads the next row.</li>\n<li><strong>Item cards are addressed three different ways</strong> depending on route. The\nproduct link is the only handle that works everywhere — and it carries\n<code>role=&quot;button&quot;</code>, so accessibility-tree queries for links miss every item.</li>\n<li><strong>Price has no test id and no stable class</strong>, anywhere.</li>\n<li><strong>The cart is a drawer, not a route.</strong> It sits in the DOM whether open or\nnot, one of eight <code>[role=&quot;dialog&quot;]</code> elements.</li>\n</ul>\n<p>Two screenshots, captured signed in with the delivery address replaced. Only the\nauthor can re-verify this entry — CI cannot, and neither can a reviewer.</p>\n"
  },
  {
    "slug": "pinterest",
    "name": "Pinterest",
    "site_url": "https://www.pinterest.com/",
    "domains": [
      "pinterest.com"
    ],
    "description": "Pinterest mapped signed in — home feed, search, board, pin detail, profile and what a dead path renders instead of a 404.",
    "categories": [
      "social"
    ],
    "author": "chiplay",
    "created": "2026-08-08",
    "updated": "2026-08-10",
    "last_verified": "2026-08-08",
    "cli_version": "0.19.0",
    "spec_version": 1,
    "method": "browser",
    "auth": "personal-account",
    "stats": {
      "views": 6,
      "components": 59,
      "requests": 12,
      "properties": 7,
      "memory": 35
    },
    "per_view": [
      {
        "name": "BoardDetail",
        "route": "/:username/:boardSlug",
        "components": 13,
        "requests": 3
      },
      {
        "name": "Profile",
        "route": "/:username",
        "components": 1,
        "requests": 0
      },
      {
        "name": "NotFound",
        "route": "/**",
        "components": 1,
        "requests": 0
      },
      {
        "name": "Home",
        "route": "/",
        "components": 6,
        "requests": 0
      },
      {
        "name": "SearchResults",
        "route": "/search/pins/",
        "components": 8,
        "requests": 0
      },
      {
        "name": "PinDetail",
        "route": "/pin/:pinId",
        "components": 15,
        "requests": 1
      }
    ],
    "screenshots": [
      "screenshots/01-home-feed.jpg",
      "screenshots/02-pin-detail.jpg",
      "screenshots/03-search-results.jpg"
    ],
    "files": [
      ".sightmap/boards.yaml",
      ".sightmap/browse.yaml",
      ".sightmap/config.yaml",
      ".sightmap/pin.yaml",
      ".sightmap/shared.yaml"
    ],
    "commit": "fbf0cecad2912405b5239b3e3aebc91d5b138aea",
    "screenshotUrls": [
      "/atlas/screenshots/pinterest/01-home-feed.jpg",
      "/atlas/screenshots/pinterest/02-pin-detail.jpg",
      "/atlas/screenshots/pinterest/03-search-results.jpg"
    ],
    "bodyHtml": "<h2>Pinterest</h2>\n<p>Six views — home, search, board, pin detail, profile, and the path that\nresolves to nothing. 59 components, 12 requests.</p>\n<h3>Why the map matters</h3>\n<p>Pinterest fails quietly. A board that no longer exists redirects to the home\nfeed, so an agent following a stale link reads someone else&#39;s recommendations\nas the board. A profile in a background tab renders its chrome and no content,\nwhich looks the same as an account with nothing in it. And the obvious selector\nfor &quot;the pin on screen&quot; only ever matches the recommendation grid around it.</p>\n<p>None of that raises an error. The map is what turns three silent wrong answers\ninto three known ones.</p>\n<h3>Try it</h3>\n<pre><code class=\"language-bash\">sightmap atlas add pinterest\n</code></pre>\n<p>Sign in first — every route here needs an account.</p>\n<h3>What bites</h3>\n<ul>\n<li><strong>Server-rendered feeds fill in a background tab; fetched ones never do.</strong>\nHome and search populate. A profile body, a board grid and a pin&#39;s related\ngrid render their containers and stay empty.</li>\n<li><strong>There is no 404.</strong> A missing board redirects to <code>/?show_error=true</code>. A\nmissing user renders the same chrome-only page as a real profile.</li>\n<li><strong><code>data-test-id=&quot;pin&quot;</code> is never the pin being viewed</strong>, on any route. It is\nalways a card in a grid.</li>\n<li><strong>Card type is a test id, not an attribute.</strong> <code>pincard-oneTap-*</code> marks a\npromoted card; the promoted share of a feed swings load to load.</li>\n<li><strong>Every <code>/resource/</code> call carries <code>source_url</code></strong>, so the route that issued a\nrequest is readable from its query string.</li>\n</ul>\n<p>Three screenshots, captured signed in. Only the author can re-verify this\nentry — CI cannot, and neither can a reviewer.</p>\n"
  },
  {
    "slug": "spotify",
    "name": "Spotify",
    "site_url": "https://open.spotify.com/",
    "domains": [
      "open.spotify.com"
    ],
    "description": "Spotify's web player mapped signed in — track, album, playlist, artist, home, search and the 404, with the playback chrome around them.",
    "categories": [
      "media"
    ],
    "author": "chiplay",
    "created": "2026-08-08",
    "updated": "2026-08-10",
    "last_verified": "2026-08-08",
    "cli_version": "0.19.0",
    "spec_version": 1,
    "method": "browser",
    "auth": "personal-account",
    "stats": {
      "views": 7,
      "components": 59,
      "requests": 4,
      "properties": 21,
      "memory": 25
    },
    "per_view": [
      {
        "name": "Home",
        "route": "/",
        "components": 8,
        "requests": 0
      },
      {
        "name": "SearchResults",
        "route": "/search/:query",
        "components": 5,
        "requests": 0
      },
      {
        "name": "NotFound",
        "route": "/**",
        "components": 1,
        "requests": 0
      },
      {
        "name": "AlbumDetail",
        "route": "/album/:albumId",
        "components": 12,
        "requests": 0
      },
      {
        "name": "PlaylistDetail",
        "route": "/playlist/:playlistId",
        "components": 6,
        "requests": 0
      },
      {
        "name": "ArtistDetail",
        "route": "/artist/:artistId",
        "components": 6,
        "requests": 0
      },
      {
        "name": "TrackDetail",
        "route": "/track/:trackId",
        "components": 8,
        "requests": 0
      }
    ],
    "screenshots": [
      "screenshots/01-home.jpg",
      "screenshots/02-artist.jpg",
      "screenshots/03-track.jpg"
    ],
    "files": [
      ".sightmap/browse.yaml",
      ".sightmap/config.yaml",
      ".sightmap/entity.yaml",
      ".sightmap/shared.yaml"
    ],
    "commit": "afb419421385ffe1c22371dc245959887488ea0f",
    "screenshotUrls": [
      "/atlas/screenshots/spotify/01-home.jpg",
      "/atlas/screenshots/spotify/02-artist.jpg",
      "/atlas/screenshots/spotify/03-track.jpg"
    ],
    "bodyHtml": "<h2>Spotify</h2>\n<p>Seven views — track, album, playlist, artist, home, search, and the 404. 59\ncomponents, 4 requests.</p>\n<h3>Why the map matters</h3>\n<p>The web player lies about where it is. Its document title is the currently\nplaying track, not the page, and the <code>main</code> landmark keeps the <em>previous</em>\nalbum&#39;s label after a client-side navigation. Both of the obvious ways to ask\n&quot;what am I looking at?&quot; return stale answers that look current.</p>\n<p>Album, playlist, artist and track look interchangeable and aren&#39;t — each has a\ndifferent container and artist has none at all. And every view is fetched\nthrough one POST endpoint, so the URL never says which page issued a call.</p>\n<h3>Try it</h3>\n<pre><code class=\"language-bash\">sightmap atlas add spotify\n</code></pre>\n<p>Sign in first — the player renders the same chrome either way, but the\nsigned-in build is the one worth delegating to.</p>\n<h3>What bites</h3>\n<ul>\n<li><strong>The document title is the playing track</strong>, not the page. Read\n<code>[data-testid=&quot;entityTitle&quot;]</code> instead.</li>\n<li><strong><code>main</code>&#39;s <code>aria-label</code> is stale by design</strong> after a client-side navigation.</li>\n<li><strong>Test the container, not the header.</strong> <code>album-page</code>, <code>playlist-page</code> and\n<code>track-page</code> identify three routes; artist has none of them.</li>\n<li><strong><code>[data-testid=&quot;track&quot;]</code> is never a track.</strong> It is an icon in the playback\nbar.</li>\n<li><strong>Signed out, the track route is a different build entirely</strong> and matches\nnothing in this corpus — which is one way to notice a lapsed session.</li>\n<li><strong>Album artwork is not in the album.</strong> Every <code>cover-art-image</code> on the page\nbelongs to the playback bar, so reaching for it returns the playing track.</li>\n<li><strong>One POST endpoint serves every view</strong>, with the operation named in the body\n— request-based view detection does not work here.</li>\n<li><strong>The 404 carries none of the chrome</strong>, which is what identifies it.</li>\n</ul>\n<p>Three screenshots, captured signed in. Only the author can re-verify this\nentry — CI cannot, and neither can a reviewer.</p>\n"
  },
  {
    "slug": "youtube",
    "name": "YouTube",
    "site_url": "https://www.youtube.com/",
    "domains": [
      "youtube.com",
      "www.youtube.com"
    ],
    "description": "YouTube mapped signed in — home, watch, search, channel, playlist and the 404, and the attribute that tells three of them apart.",
    "categories": [
      "media"
    ],
    "author": "chiplay",
    "created": "2026-08-08",
    "updated": "2026-08-10",
    "last_verified": "2026-08-08",
    "cli_version": "0.19.0",
    "spec_version": 1,
    "method": "browser",
    "auth": "personal-account",
    "stats": {
      "views": 6,
      "components": 47,
      "requests": 5,
      "properties": 4,
      "memory": 30
    },
    "per_view": [
      {
        "name": "SearchResults",
        "route": "/results",
        "components": 9,
        "requests": 0
      },
      {
        "name": "Channel",
        "route": "/@:handle",
        "components": 8,
        "requests": 0
      },
      {
        "name": "Playlist",
        "route": "/playlist",
        "components": 6,
        "requests": 0
      },
      {
        "name": "NotFound",
        "route": "/**",
        "components": 1,
        "requests": 0
      },
      {
        "name": "Home",
        "route": "/",
        "components": 5,
        "requests": 0
      },
      {
        "name": "Watch",
        "route": "/watch",
        "components": 13,
        "requests": 0
      }
    ],
    "screenshots": [
      "screenshots/01-home-feed.jpg",
      "screenshots/02-watch.jpg",
      "screenshots/03-channel.jpg"
    ],
    "files": [
      ".sightmap/browse.yaml",
      ".sightmap/config.yaml",
      ".sightmap/home.yaml",
      ".sightmap/shared.yaml",
      ".sightmap/watch.yaml"
    ],
    "commit": "f9cd4c5ead96b02a8bf034afc8aa0b86dd5d3721",
    "screenshotUrls": [
      "/atlas/screenshots/youtube/01-home-feed.jpg",
      "/atlas/screenshots/youtube/02-watch.jpg",
      "/atlas/screenshots/youtube/03-channel.jpg"
    ],
    "bodyHtml": "<h2>YouTube</h2>\n<p>Six views — home, watch, search, channel, playlist, and the 404. 47 components,\n5 requests.</p>\n<h3>Why the map matters</h3>\n<p>YouTube&#39;s custom elements look like a clean API and aren&#39;t. Home, channel and\nplaylist are all <code>ytd-browse</code>; only an attribute separates them, so route\ndetection by element silently conflates three pages. Video rows ship under two\nrenderers at once, so counting either alone undercounts. And the selectors most\nagents already carry — <code>input[name=&quot;search_query&quot;]</code>,\n<code>ytd-playlist-video-renderer</code> — match nothing at all now, returning empty lists\nrather than errors.</p>\n<h3>Try it</h3>\n<pre><code class=\"language-bash\">sightmap atlas add youtube\n</code></pre>\n<p>Sign in first if you want the home feed; watch, search and channel work either\nway.</p>\n<h3>What bites</h3>\n<ul>\n<li><strong>Three routes share one element.</strong> Home, channel and playlist are all\n<code>ytd-browse</code>, separated only by its <code>page-subtype</code> attribute.</li>\n<li><strong>The search field is a <code>textarea</code></strong>, not an input.</li>\n<li><strong>Video rows use two renderers at once.</strong> Search carries both\n<code>ytd-video-renderer</code> and <code>yt-lockup-view-model</code>. On a playlist the legacy\nrenderer matches nothing.</li>\n<li><strong>Subscribe is a different element on channel and on watch.</strong></li>\n<li><strong>The watch page hides duplicate copies of its own controls</strong>, and for the\nlike button the first match in document order is the hidden one.</li>\n<li><strong>Ids are not unique</strong>, and the icon sprite owns generic ones like <code>#add</code>.</li>\n</ul>\n<p>Three screenshots, captured signed in. Only the author can re-verify this\nentry — CI cannot, and neither can a reviewer.</p>\n"
  },
  {
    "slug": "zillow",
    "name": "Zillow",
    "site_url": "https://www.zillow.com/",
    "domains": [
      "zillow.com",
      "www.zillow.com"
    ],
    "description": "Zillow mapped signed in — landing page, search, listing detail, saved homes and the 404, and their three incompatible card conventions.",
    "categories": [
      "commerce"
    ],
    "author": "chiplay",
    "created": "2026-08-08",
    "updated": "2026-08-10",
    "last_verified": "2026-08-08",
    "cli_version": "0.19.0",
    "spec_version": 1,
    "method": "browser",
    "auth": "personal-account",
    "stats": {
      "views": 5,
      "components": 59,
      "requests": 4,
      "properties": 5,
      "memory": 31
    },
    "per_view": [
      {
        "name": "Home",
        "route": "/",
        "components": 6,
        "requests": 0
      },
      {
        "name": "SearchResults",
        "route": "/homes/:filters/:location_rb",
        "components": 15,
        "requests": 0
      },
      {
        "name": "ListingDetail",
        "route": "/homedetails/:addressSlug/:zpid",
        "components": 24,
        "requests": 0
      },
      {
        "name": "SavedHomes",
        "route": "/myzillow/favorites",
        "components": 10,
        "requests": 0
      },
      {
        "name": "NotFound",
        "route": "/**",
        "components": 2,
        "requests": 0
      }
    ],
    "screenshots": [
      "screenshots/01-landing.jpg",
      "screenshots/02-search-results.jpg"
    ],
    "files": [
      ".sightmap/config.yaml",
      ".sightmap/home.yaml",
      ".sightmap/listings.yaml",
      ".sightmap/shared.yaml"
    ],
    "commit": "37b735d73531c9bc67cd6ac00f1b94a807a236c9",
    "screenshotUrls": [
      "/atlas/screenshots/zillow/01-landing.jpg",
      "/atlas/screenshots/zillow/02-search-results.jpg"
    ],
    "bodyHtml": "<h2>Zillow</h2>\n<p>Five views — the signed-in landing page, search results, a listing, saved homes,\nand the 404. 59 components, 4 requests.</p>\n<h3>Why the map matters</h3>\n<p>Three routes list homes and no card selector works across all three. Worse, the\nsearch page&#39;s card test id is reused on a listing page, where it matches five\n<em>other</em> homes in the similar-homes rail rather than the one being viewed — so\nthe wrong answer looks exactly like the right one.</p>\n<p>The two facts an agent most wants from a listing, price and address, have no\ntest id at all.</p>\n<h3>Try it</h3>\n<pre><code class=\"language-bash\">sightmap atlas add zillow\n</code></pre>\n<p>Search, listings and the 404 work signed out; the landing carousel and saved\nhomes need an account.</p>\n<h3>What bites</h3>\n<ul>\n<li><strong>Three routes, three card conventions</strong> — and on a listing page,\n<code>property-card</code> means the similar-homes rail, not the listing.</li>\n<li><strong>Price and address have no test id.</strong> Read them from the <code>h1</code> and the title.</li>\n<li><strong><code>data-price-row</code> is not a row.</strong> It is a <code>span</code> holding one price; the real\nrow has no test id, so the history columns must be zipped by index.</li>\n<li><strong>Half a listing page renders twice</strong>, header facts and media tabs included.</li>\n<li><strong>Search filters are path segments, not query parameters.</strong></li>\n<li><strong>The 404&#39;s <code>document.title</code> is the empty string</strong> — the only route where\nthat is true, and the cheapest test for it.</li>\n</ul>\n<h3>Personal data</h3>\n<p>Listing pages carry home addresses and agent contact details. Selectors and what\nthey mean are recorded; values are not. No address, price, agent name or phone\nnumber appears in the corpus. The two screenshots show public for-sale listings\nas Zillow publishes them.</p>\n<p>Only the author can re-verify this entry — CI cannot, and neither can a\nreviewer.</p>\n"
  },
  {
    "slug": "airbnb",
    "name": "Airbnb",
    "site_url": "https://www.airbnb.com/",
    "domains": [
      "airbnb.com"
    ],
    "description": "Stay search with its live map, listing pages built from named sections, city landing pages, and a model 404.",
    "categories": [
      "travel"
    ],
    "author": "chiplay",
    "created": "2026-08-07",
    "updated": "2026-08-08",
    "last_verified": "2026-08-08",
    "cli_version": "0.18.0",
    "spec_version": 1,
    "method": "browser",
    "auth": "none",
    "stats": {
      "views": 5,
      "components": 53,
      "requests": 16,
      "properties": 20,
      "memory": 33
    },
    "per_view": [
      {
        "name": "CityLanding",
        "route": "/:citySlug/stays",
        "components": 6,
        "requests": 0
      },
      {
        "name": "Home",
        "route": "/",
        "components": 3,
        "requests": 1
      },
      {
        "name": "ListingDetail",
        "route": "/rooms/:listingId",
        "components": 19,
        "requests": 4
      },
      {
        "name": "NotFound",
        "route": "/404",
        "components": 1,
        "requests": 0
      },
      {
        "name": "SearchResults",
        "route": "/s/:location/homes",
        "components": 14,
        "requests": 3
      }
    ],
    "screenshots": [
      "screenshots/01-search-results.webp"
    ],
    "files": [
      ".sightmap/city.yaml",
      ".sightmap/config.yaml",
      ".sightmap/home.yaml",
      ".sightmap/listing.yaml",
      ".sightmap/not-found.yaml",
      ".sightmap/search.yaml",
      ".sightmap/shared.yaml"
    ],
    "commit": "18315720bf349f7a7a3f1b5fe4082469fcffebc6",
    "screenshotUrls": [
      "/atlas/screenshots/airbnb/01-search-results.webp"
    ],
    "bodyHtml": "<h2>Airbnb</h2>\n<p>Stay search and listings, mapped as a signed-out visitor. A listing is a\ndocument of named sections rather than a product with attributes, and search is\npaired with a live map.</p>\n<h3>Coverage</h3>\n<div class=\"atlas-table-wrap\"><table class=\"atlas-table\">\n<thead>\n<tr>\n<th>View</th>\n<th>Route</th>\n<th>What it holds</th>\n</tr>\n</thead>\n<tbody><tr>\n<td><code>Home</code></td>\n<td><code>/</code></td>\n<td>Expanded search form and vertical tabs</td>\n</tr>\n<tr>\n<td><code>SearchResults</code></td>\n<td><code>/s/:location/homes</code></td>\n<td>Listing card grid beside a Google Map</td>\n</tr>\n<tr>\n<td><code>ListingDetail</code></td>\n<td><code>/rooms/:listingId</code></td>\n<td>Sectioned listing page and booking panel</td>\n</tr>\n<tr>\n<td><code>CityLanding</code></td>\n<td><code>/:citySlug/stays</code></td>\n<td>SEO carousels of listing cards</td>\n</tr>\n<tr>\n<td><code>NotFound</code></td>\n<td><code>/404</code></td>\n<td>Error page, reached by redirect</td>\n</tr>\n</tbody></table></div>\n<p><code>SkipLinks</code>, <code>AppRoot</code>, <code>PageHeader</code>, <code>PageMain</code>, <code>PageFooter</code>, <code>SearchHeader</code>,\n<code>HeaderProfileMenu</code>, <code>TabListWrapper</code>, and <code>ContentScroller</code> are global, and not\none of them appears on all five views. All five views report <code>0 orphaned</code>\ncoverage, with every selector <code>sel-probe</code>d against every view on 2026-08-08.</p>\n<h3>Hazards</h3>\n<p><strong>Four naming conventions, each covering a different part of the site.</strong>\nKebab-case testids (<code>listing-card-title</code>, <code>little-search</code>) name interactive\ncomponents. UPPER_SNAKE testids (<code>LISTINGS_CAROUSEL</code>, <code>HEADER</code>, <code>BANNER</code>) name\nsections on SEO landing pages. <code>data-section-id</code> (<code>TITLE_DEFAULT</code>,\n<code>AMENITIES_DEFAULT</code>) names the structure of a listing page. Slash-namespaced\ntestids (<code>map/GoogleMap</code>, <code>map/ZoomInButton</code>) belong to the map. An agent\nquerying only <code>data-testid</code> never sees a listing page&#39;s outline at all.</p>\n<p><strong>Section ids carry experiment variants.</strong> <code>OVERVIEW_DEFAULT_V2</code> sits alongside\n<code>TITLE_DEFAULT</code> on the same page, so the exact id depends on which variant was\nserved. Match on the prefix.</p>\n<p><strong>Cards and map markers are different trees describing the same listings.</strong> One\nload had 28 cards and 20 markers, because the map only renders markers inside the\ncurrent viewport. Neither number is the result count.</p>\n<p><strong>Prices are a function of the search, not the listing.</strong> The dates and guest\ncount in the search state determine what a card shows, so a price is only\nmeaningful together with the query that produced it.</p>\n<p><strong>The search control changes shape between routes.</strong> The home page uses the\nexpanded <code>structured-search-input-*</code> form; every other route uses the collapsed\n<code>little-search</code>. Learning one does not find the other.</p>\n<p><strong>Testids can encode state.</strong> <code>pdp-save-button-unsaved</code> becomes the saved variant\nonce toggled, so a selector for the unsaved form stops matching after a save.</p>\n<p><strong>Class names are worthless here.</strong> They are Linaria output, and 31 elements\ncarry <code>data-testid=&quot;linaria-injector&quot;</code> as style injection points. Nothing on this\nsite should be selected by class.</p>\n<h3>The 404</h3>\n<p>An unmatched path redirects to <code>/404</code>, the title reads &quot;404 Page Not Found -\nAirbnb&quot;, and the body spells out the error code. Path, title, and text all agree,\nso any one of the three detects it. The page also drops the React root entirely,\nwhich makes the absence of <code>#react-application</code> a fourth independent signal.</p>\n<h3>Known gaps</h3>\n<p>Booking stops at the reserve button. Activating it starts a real reservation\nflow on a live marketplace.</p>\n<p>Accounts, wishlists, trips, and messaging are out of scope per\n<a href=\"../../docs/POLICY.md\">docs/POLICY.md</a>.</p>\n<p>Experiences and Services are not mapped. Both normalize away from <code>/s/</code> to\ndifferent route shapes (<code>/s/Paris--France/experiences</code> becomes\n<code>/ile-de-france/things-to-do</code>), and each deserves its own view rather than being\nfolded into the stay search.</p>\n<p><code>ListingDetail</code> is pinned to one listing, which happens to be a hotel and so\ncarries <code>PROPERTY_AVAILABLE_ROOMS</code>. A whole-home listing renders a different\nsubset of sections; the section vocabulary holds, the specific list does not.</p>\n<h3>Screenshots</h3>\n<p>One screenshot, of signed-out search results. The listing detail page is\ndeliberately not pictured: it carries host names and guest reviews, and\n<a href=\"../../docs/POLICY.md\">docs/POLICY.md</a> rules out personal data in screenshots.\nThe corpus records that page&#39;s structure without reproducing its content.</p>\n"
  },
  {
    "slug": "amazon",
    "name": "Amazon",
    "site_url": "https://www.amazon.com/",
    "domains": [
      "amazon.com"
    ],
    "description": "US marketplace — search, product detail, best-seller charts, and a text-free 404, mapped signed-out.",
    "categories": [
      "commerce"
    ],
    "author": "chiplay",
    "created": "2026-08-06",
    "updated": "2026-08-08",
    "last_verified": "2026-08-06",
    "cli_version": "0.18.0",
    "spec_version": 1,
    "method": "browser",
    "auth": "none",
    "stats": {
      "views": 5,
      "components": 47,
      "requests": 12,
      "properties": 23,
      "memory": 33
    },
    "per_view": [
      {
        "name": "BestSellers",
        "route": "/gp/bestsellers",
        "components": 4,
        "requests": 1
      },
      {
        "name": "Home",
        "route": "/",
        "components": 4,
        "requests": 1
      },
      {
        "name": "NotFound",
        "route": "/**",
        "components": 5,
        "requests": 0
      },
      {
        "name": "ProductDetail",
        "route": "/dp/:asin",
        "components": 15,
        "requests": 3
      },
      {
        "name": "SearchResults",
        "route": "/s",
        "components": 10,
        "requests": 3
      }
    ],
    "screenshots": [
      "screenshots/01-search-results.webp",
      "screenshots/02-not-found.webp"
    ],
    "files": [
      ".sightmap/bestsellers.yaml",
      ".sightmap/config.yaml",
      ".sightmap/home.yaml",
      ".sightmap/not-found.yaml",
      ".sightmap/product.yaml",
      ".sightmap/search.yaml",
      ".sightmap/shared.yaml"
    ],
    "commit": "18315720bf349f7a7a3f1b5fe4082469fcffebc6",
    "screenshotUrls": [
      "/atlas/screenshots/amazon/01-search-results.webp",
      "/atlas/screenshots/amazon/02-not-found.webp"
    ],
    "bodyHtml": "<h2>Amazon</h2>\n<p>The US marketplace, mapped as a signed-out shopper.</p>\n<h3>Coverage</h3>\n<div class=\"atlas-table-wrap\"><table class=\"atlas-table\">\n<thead>\n<tr>\n<th>View</th>\n<th>Route</th>\n<th>What it holds</th>\n</tr>\n</thead>\n<tbody><tr>\n<td><code>Home</code></td>\n<td><code>/</code></td>\n<td>Shoppable card deck and recommendation rails</td>\n</tr>\n<tr>\n<td><code>SearchResults</code></td>\n<td><code>/s</code></td>\n<td>Refinement rail, 48-card result grid, pagination</td>\n</tr>\n<tr>\n<td><code>ProductDetail</code></td>\n<td><code>/dp/:asin</code></td>\n<td>Three-column layout, buy box, feature slots</td>\n</tr>\n<tr>\n<td><code>BestSellers</code></td>\n<td><code>/gp/bestsellers</code></td>\n<td>Department rail and ranked charts</td>\n</tr>\n<tr>\n<td><code>NotFound</code></td>\n<td><code>/**</code></td>\n<td>Text-free error page</td>\n</tr>\n</tbody></table></div>\n<p><code>GlobalNav</code>, <code>KeyboardShortcutMenu</code>, and <code>PageRoot</code> are global. All five views\nreport <code>0 orphaned</code> coverage, with every selector <code>sel-probe</code>d on 2026-08-06.</p>\n<h3>Hazards</h3>\n<p><strong>The 404 has no text at all.</strong> <code>document.body.innerText</code> is the empty string.\nThe apology is the <code>alt</code> attribute of an image, the three links have image\ncontent and empty text, and the markup is hand-minified with single-letter ids\n(<code>#a</code> form, <code>#e</code> input, <code>#f</code> submit). An agent that detects errors by reading\npage copy finds nothing and will most likely decide the page is still loading.\nWhat works: <code>document.title === &quot;Page Not Found&quot;</code>, the absence of the entire\n<code>nav-</code> chrome, and the image <code>alt</code> text.</p>\n<p><strong>Ids are duplicated on the product page.</strong> Amazon renders several buy-box\nvariants and hides all but one, so <code>#add-to-cart-button</code> and <code>#buy-now-button</code>\neach match twice and <code>#availability</code> matches three times. Every duplicate sits\ninside <code>#buybox</code> and the hidden ones measure 0×0. <code>querySelector</code> returns\ndocument order, which is not a guarantee of visibility. There is also an\nunrelated <code>#add-to-cart-btn</code> placeholder outside the page root, making three ids\nin that family.</p>\n<p><strong>Most of the product page is empty.</strong> The page is built from slots whose ids end\n<code>_feature_div</code>. On the article mapped here there were 541 of them and 501\nrendered with zero height. A slot existing means the template reserved it, not\nthat it has content.</p>\n<p><strong><code>[data-asin]</code> is not the result selector.</strong> It matches 88 elements on a search\npage that has 48 results, because carousels, ad slots, and recommendation strips\ncarry ASINs too. Use <code>[data-component-type=&quot;s-search-result&quot;]</code>, and read fields\nthrough the <code>data-cy</code> attributes (<code>title-recipe</code>, <code>price-recipe</code>,\n<code>reviews-block</code>, <code>delivery-recipe</code>), which appear exactly once per card.</p>\n<p><strong>Ids that look stable and are not.</strong> <code>#CardInstance&lt;random&gt;</code> on the best-seller\ncharts is regenerated per render. <code>#wd-shoppable-N</code> on the home page is\npositional, so the number identifies a slot rather than a promotion.</p>\n<p><strong>The page depends on where you are.</strong> The header carries an IP-inferred delivery\nlocation, and prices, availability, and delivery estimates all follow from it.\nTwo agents in different places get different pages at the same URL.</p>\n<h3>Known gaps</h3>\n<p>Cart and checkout stop at the buy-box buttons. Going further means putting items\ninto a real cart on a live marketplace.</p>\n<p>Signed-in surfaces (orders, lists, recommendations tied to an account) are out of\nscope per <a href=\"../../docs/POLICY.md\">docs/POLICY.md</a>.</p>\n<p><code>ProductDetail</code> is pinned to one ASIN. Feature slots vary enormously by\ncategory, so a media or grocery article renders a substantially different set of\nslots than the accessory mapped here. The three-column skeleton holds; the slots\ninside it do not.</p>\n<p><code>SearchResults</code> and <code>BestSellers</code> were mapped from one query and the top-level\nchart. Deeper chart departments use the same components.</p>\n<h3>Screenshots</h3>\n<p>Signed-out views of public pages. The search screenshot shows the header&#39;s\nIP-inferred delivery city and ZIP, which is Amazon&#39;s geolocation guess rather\nthan anything a visitor entered. The 404 screenshot is included because the page\nis unusual enough to be worth seeing.</p>\n"
  },
  {
    "slug": "apple",
    "name": "Apple",
    "site_url": "https://www.apple.com/",
    "domains": [
      "apple.com"
    ],
    "description": "Editorial product pages and the configure-and-buy store, two systems sharing one header, plus a 404 that changes language with the URL.",
    "categories": [
      "commerce"
    ],
    "author": "chiplay",
    "created": "2026-08-07",
    "updated": "2026-08-08",
    "last_verified": "2026-08-07",
    "cli_version": "0.18.0",
    "spec_version": 1,
    "method": "browser",
    "auth": "none",
    "stats": {
      "views": 5,
      "components": 54,
      "requests": 10,
      "properties": 23,
      "memory": 38
    },
    "per_view": [
      {
        "name": "BuyFlow",
        "route": "/**/shop/buy-mac/:model",
        "components": 16,
        "requests": 3
      },
      {
        "name": "Home",
        "route": "/",
        "components": 7,
        "requests": 0
      },
      {
        "name": "NotFound",
        "route": "/**",
        "components": 4,
        "requests": 0
      },
      {
        "name": "ProductMarketing",
        "route": "/:productSlug",
        "components": 10,
        "requests": 2
      },
      {
        "name": "SearchResults",
        "route": "/:locale/search/:query",
        "components": 7,
        "requests": 1
      }
    ],
    "screenshots": [
      "screenshots/01-buy-flow.webp",
      "screenshots/02-search-results.webp"
    ],
    "files": [
      ".sightmap/buy.yaml",
      ".sightmap/config.yaml",
      ".sightmap/home.yaml",
      ".sightmap/not-found.yaml",
      ".sightmap/product-page.yaml",
      ".sightmap/search.yaml",
      ".sightmap/shared.yaml"
    ],
    "commit": "18315720bf349f7a7a3f1b5fe4082469fcffebc6",
    "screenshotUrls": [
      "/atlas/screenshots/apple/01-buy-flow.webp",
      "/atlas/screenshots/apple/02-search-results.webp"
    ],
    "bodyHtml": "<h2>Apple</h2>\n<p>apple.com, mapped as a signed-out visitor.</p>\n<h3>Coverage</h3>\n<div class=\"atlas-table-wrap\"><table class=\"atlas-table\">\n<thead>\n<tr>\n<th>View</th>\n<th>Route</th>\n<th>What it holds</th>\n</tr>\n</thead>\n<tbody><tr>\n<td><code>Home</code></td>\n<td><code>/</code></td>\n<td>Promotional tiles and a media gallery</td>\n</tr>\n<tr>\n<td><code>SearchResults</code></td>\n<td><code>/:locale/search/:query</code></td>\n<td>Tabbed results across four verticals</td>\n</tr>\n<tr>\n<td><code>ProductMarketing</code></td>\n<td><code>/:productSlug</code></td>\n<td>Local nav, marquee, scroll galleries</td>\n</tr>\n<tr>\n<td><code>BuyFlow</code></td>\n<td><code>/**/shop/buy-mac/:model</code></td>\n<td>Stepped configuration with a running price</td>\n</tr>\n<tr>\n<td><code>NotFound</code></td>\n<td><code>/**</code></td>\n<td>Apology, search box, sitemap link</td>\n</tr>\n</tbody></table></div>\n<p><code>GlobalHeader</code>, <code>NavCurtain</code>, <code>PageRoot</code>, <code>MainRegion</code>, <code>AnnouncementPortal</code>,\n<code>NavSearchResultCount</code>, and <code>GlobalFooter</code> are global. All five views report\n<code>0 orphaned</code> coverage, with every selector <code>sel-probe</code>d on 2026-08-07.</p>\n<h3>Hazards</h3>\n<p><strong>The 404 changes language with the URL.</strong> The first path segment is a locale\ncode, so <code>/fr/nope-xyz</code> returns &quot;Page introuvable&quot;, <code>/no/nope-xyz</code> returns\nNorwegian, and <code>/zzz/nope-xyz</code> returns English. An agent that detects errors by\nmatching the message text gets a different string depending on a path segment it\nmay never have chosen deliberately. Match on structure instead.</p>\n<p><strong>A single-segment unknown path is indistinguishable from a product page.</strong>\nMarketing pages live at <code>/:productSlug</code>, so <code>/no-such-page</code> has the same route\nshape as <code>/macbook-air</code>. The structural tell is <code>#ac-localnav</code>, which every\nmarketing page carries and the error page does not.</p>\n<p><strong>Marketing pages cannot sell anything.</strong> <code>/macbook-air/</code> is editorial — a\nstarting price and a link, with no configurator and no add-to-cart. The purchase\nsurface is <code>/shop/buy-mac/macbook-air</code>. These are two different systems sharing\none header, and confusing them is the easiest mistake on this site.</p>\n<p><strong>Most store URLs you find by crawling are aliases.</strong> There is a permalink layer\nat <code>/us/shop/goto/</code> using underscores that redirects to the hyphenated canonical\nroute. The home page alone carries over a hundred of them.</p>\n<p><strong>Two ids for one footer.</strong> <code>#ac-globalfooter</code> on the landing and marketing\npages, <code>#global-footersection</code> on search and the store. Matching only one finds\nthe footer on about half the site.</p>\n<p><strong>Buy-flow options are ordered steps, not fields.</strong> Later steps depend on earlier\nones, so a configuration cannot be filled in arbitrary order. The sticky bar\ncarries the running total, which diverges from the header&#39;s starting price as\nsoon as anything is selected.</p>\n<p><strong>Ids that are not addressable.</strong> React <code>useId</code> produces <code>#_r_3_</code> for search tab\npanels and <code>#announce-message-_r_8_</code> for the nine live regions inside <code>#portal</code>.\nThey change per render and are not valid CSS identifiers unescaped.</p>\n<p><strong>Marketing pages are enormous and video-driven.</strong> <code>/macbook-air/</code> is roughly\n28,000 pixels tall, with paired <code>-startframe-</code> and <code>-endframe-</code> images standing\nin for video until it plays. A snapshot at the top captures placeholders.</p>\n<h3>Known gaps</h3>\n<p>The buy flow is mapped through configuration and stops before the bag. Going\nfurther means starting a real purchase.</p>\n<p>Apple Account, order status, and anything behind sign-in are out of scope per\n<a href=\"../../docs/POLICY.md\">docs/POLICY.md</a>.</p>\n<p>Only the US locale is mapped. Since the first path segment selects locale, other\nmarkets serve different prices, availability, and copy from the same structure.</p>\n<p><code>ProductMarketing</code> and <code>BuyFlow</code> are each pinned to one product. The <code>rf-bfe-</code>\nand <code>.section</code> vocabularies hold across the range; which steps and sections\nappear does not.</p>\n<p><code>SearchResults</code> was mapped on the Explore tab. The other three tabs\n(Accessories, Support, Find a Store) use the same shell and were not populated.</p>\n<h3>Screenshots</h3>\n<p>Signed-out views of public pages.</p>\n"
  },
  {
    "slug": "ebay",
    "name": "eBay",
    "site_url": "https://www.ebay.com/",
    "domains": [
      "ebay.com"
    ],
    "description": "Marketplace search, category browse, item detail, and the live-shopping hub, mapped as a signed-out shopper.",
    "categories": [
      "commerce"
    ],
    "author": "chiplay",
    "created": "2026-08-06",
    "updated": "2026-08-08",
    "last_verified": "2026-08-06",
    "cli_version": "0.18.0",
    "spec_version": 1,
    "method": "browser",
    "auth": "none",
    "stats": {
      "views": 6,
      "components": 70,
      "requests": 9,
      "properties": 25,
      "memory": 58
    },
    "per_view": [
      {
        "name": "CategoryBrowse",
        "route": "/b/:categoryName/:categoryId/:browseNode",
        "components": 17,
        "requests": 2
      },
      {
        "name": "Home",
        "route": "/",
        "components": 6,
        "requests": 0
      },
      {
        "name": "ItemDetail",
        "route": "/itm/:itemId",
        "components": 12,
        "requests": 0
      },
      {
        "name": "LiveHub",
        "route": "/ebaylive",
        "components": 3,
        "requests": 0
      },
      {
        "name": "NotFound",
        "route": "/**",
        "components": 2,
        "requests": 0
      },
      {
        "name": "SearchResults",
        "route": "/sch/i.html",
        "components": 21,
        "requests": 2
      }
    ],
    "screenshots": [
      "screenshots/01-search-results.webp",
      "screenshots/02-item-detail.webp"
    ],
    "files": [
      ".sightmap/category.yaml",
      ".sightmap/config.yaml",
      ".sightmap/home.yaml",
      ".sightmap/item.yaml",
      ".sightmap/live.yaml",
      ".sightmap/not-found.yaml",
      ".sightmap/search.yaml",
      ".sightmap/shared.yaml"
    ],
    "commit": "de495d2949becc39e84a8fcd5f0a83ad407a00da",
    "screenshotUrls": [
      "/atlas/screenshots/ebay/01-search-results.webp",
      "/atlas/screenshots/ebay/02-item-detail.webp"
    ],
    "bodyHtml": "<h2>eBay</h2>\n<p>Everything an agent can reach on ebay.com without an account: find something,\nnarrow it down, and read the listing.</p>\n<h3>Coverage</h3>\n<div class=\"atlas-table-wrap\"><table class=\"atlas-table\">\n<thead>\n<tr>\n<th>View</th>\n<th>Route</th>\n<th>What it holds</th>\n</tr>\n</thead>\n<tbody><tr>\n<td><code>Home</code></td>\n<td><code>/</code></td>\n<td>Category flyout, live-shopping carousel, rotating promo modules</td>\n</tr>\n<tr>\n<td><code>SearchResults</code></td>\n<td><code>/sch/i.html</code></td>\n<td>Filter rail, result river, sort and pagination controls</td>\n</tr>\n<tr>\n<td><code>CategoryBrowse</code></td>\n<td><code>/b/:categoryName/:categoryId/:browseNode</code></td>\n<td>Breadcrumbs, category tree, refinements, item grid</td>\n</tr>\n<tr>\n<td><code>ItemDetail</code></td>\n<td><code>/itm/:itemId</code></td>\n<td>Gallery, title, price, quantity, buy actions, shipping, returns</td>\n</tr>\n<tr>\n<td><code>LiveHub</code></td>\n<td><code>/ebaylive</code></td>\n<td>Filterable feed of live and upcoming shopping streams</td>\n</tr>\n<tr>\n<td><code>NotFound</code></td>\n<td><code>/**</code></td>\n<td>Catch-all error page</td>\n</tr>\n</tbody></table></div>\n<p><code>GlobalHeader</code>, <code>GlobalFooter</code>, <code>GlobalPromoBanner</code>, and <code>FloatingHelp</code> are\nglobal components. All six views report <code>0 orphaned</code> coverage, with every\nselector <code>sel-probe</code>d on 2026-08-06.</p>\n<h3>Hazards</h3>\n<p><strong>A category URL can lie about which category you are on.</strong> The name segment in\n<code>/b/:categoryName/:categoryId/:browseNode</code> is decorative.\n<code>/b/Totally-Made-Up-Name/220/bn_1865497</code> loads Toys &amp; Hobbies and quietly\nrewrites the path to the canonical name. A mismatched name and id pair is worse:\n<code>/b/Cordless-Drills/184644/bn_1853799</code> serves Porcelain Nativity Items with a 200\nand no warning at all. Read <code>.textual-display</code> after the page loads; the URL you\nrequested proves nothing.</p>\n<p><strong>Three surfaces list products and no two share a card class.</strong> Search uses\n<code>li.s-card</code>, category browse uses <code>.brwrvr__item-card</code>, promo carousels use\n<code>.brw-product-card</code>, and eBay Live uses <code>.dp-subgrid-item</code>. There is no single\ncard selector, and reaching for one is how a scraper silently returns nothing on\nhalf the site.</p>\n<p><strong>Scope result cards or overcount them.</strong> The bare <code>.s-card</code> class also matches\nsponsored and related-item cards sitting outside the results list, so\n<code>ul.srp-results &gt; li.s-card</code> is the selector that returns the 60 results the page\nactually has. The same applies to <code>a.s-card__link</code>, which matches once per\ncarousel thumbnail and lands near 150 on a 60-result page until you exclude\n<code>.image-treatment</code>.</p>\n<p><strong>Filter group ids are positional and shift with the query.</strong> <code>#x-refine__group__0</code>\nthrough <code>__8</code> are assigned in render order, so the price group is not reliably\ngroup 4. Match on the <code>.x-refine__item__title</code> heading text instead. Buying\nFormat, Condition, and Item Location are not in the left rail at all; they render\nas menus in the controls bar.</p>\n<p><strong>Class names split into two families and only one is safe.</strong> Prefixed names\n(<code>gh-</code>, <code>srp-</code>, <code>brw-</code>, <code>x-refine__</code>) are structural and survive deploys. Bare\nshort names like <code>.esJT</code>, <code>._5hsT</code>, and <code>.Jd4g</code> are compiled output. So are the\nhome page&#39;s <code>s0-0-1-1-0-2-…-container</code> ids, which encode a module&#39;s position in\none particular render.</p>\n<p><strong>A cold profile gets a proof-of-work splash first.</strong> The first request lands on\n<code>/splashui/challenge</code>, the browser answers it with <code>argon2.wasm</code>, and then the\nreal URL loads. Nothing is required of the agent, but the first page is slower\nand <code>document.referrer</code> points at the challenge rather than wherever you came\nfrom.</p>\n<h3>Known gaps</h3>\n<p>Cart and checkout are mapped only as far as the buy-box buttons on\n<code>ItemDetail</code>. Going further means adding items to a cart and moving toward a\npurchase on a live marketplace, which is not something a map should do to\nsomeone else&#39;s storefront.</p>\n<p>Signed-in surfaces (My eBay, Watchlist, purchase history) are out of scope per\n<a href=\"../../docs/POLICY.md\">docs/POLICY.md</a>. The header links to them from every\nroute, so an agent following the global nav will hit a login wall there and\nnowhere else.</p>\n<p><code>ItemDetail</code> is pinned to one real listing, and listings end. When that URL stops\nresolving, re-probe against any current <code>/itm/</code> id; nothing in the view depends\non that particular item.</p>\n<h3>Screenshots</h3>\n<p>Both are signed-out views of public catalog pages. The search screenshot shows a\n&quot;Shipping to&quot; ZIP that eBay inferred from the capture machine&#39;s IP address, which\nis the store&#39;s regional default rather than anything a visitor entered.</p>\n"
  },
  {
    "slug": "github",
    "name": "GitHub",
    "site_url": "https://github.com/",
    "domains": [
      "github.com"
    ],
    "description": "Public repository hosting — org, repo, file, issue, pull request, and release views, mapped signed-out across two frontends.",
    "categories": [
      "devtools",
      "saas"
    ],
    "author": "chiplay",
    "created": "2026-08-08",
    "updated": "2026-08-08",
    "last_verified": "2026-08-08",
    "cli_version": "0.19.0",
    "spec_version": 1,
    "method": "browser",
    "auth": "none",
    "stats": {
      "views": 8,
      "components": 46,
      "requests": 23,
      "properties": 22,
      "memory": 36
    },
    "per_view": [
      {
        "name": "PullList",
        "route": "/:owner/:repo/pulls",
        "components": 4,
        "requests": 1
      },
      {
        "name": "IssueList",
        "route": "/:owner/:repo/issues",
        "components": 8,
        "requests": 2
      },
      {
        "name": "Releases",
        "route": "/:owner/:repo/releases",
        "components": 1,
        "requests": 0
      },
      {
        "name": "NotFound",
        "route": "/**",
        "components": 2,
        "requests": 0
      },
      {
        "name": "OrgProfile",
        "route": "/:org",
        "components": 6,
        "requests": 3
      },
      {
        "name": "PullDetail",
        "route": "/:owner/:repo/pull/:number",
        "components": 3,
        "requests": 6
      },
      {
        "name": "RepoHome",
        "route": "/:owner/:repo",
        "components": 6,
        "requests": 6
      },
      {
        "name": "FileBlob",
        "route": "/:owner/:repo/blob/:ref/**",
        "components": 4,
        "requests": 2
      }
    ],
    "screenshots": [
      "screenshots/01-repo-home.webp",
      "screenshots/02-file-blob.webp",
      "screenshots/03-issue-list.webp",
      "screenshots/04-not-found.webp"
    ],
    "files": [
      ".sightmap/config.yaml",
      ".sightmap/lists.yaml",
      ".sightmap/not-found.yaml",
      ".sightmap/org.yaml",
      ".sightmap/pull-detail.yaml",
      ".sightmap/repo.yaml",
      ".sightmap/shared.yaml"
    ],
    "commit": "18315720bf349f7a7a3f1b5fe4082469fcffebc6",
    "screenshotUrls": [
      "/atlas/screenshots/github/01-repo-home.webp",
      "/atlas/screenshots/github/02-file-blob.webp",
      "/atlas/screenshots/github/03-issue-list.webp",
      "/atlas/screenshots/github/04-not-found.webp"
    ],
    "bodyHtml": "<h2>GitHub</h2>\n<p>The public, signed-out surface of github.com, mapped against the <code>sightmap</code>\norganization and its repositories.</p>\n<h3>Coverage</h3>\n<div class=\"atlas-table-wrap\"><table class=\"atlas-table\">\n<thead>\n<tr>\n<th>View</th>\n<th>Route</th>\n<th>What it holds</th>\n</tr>\n</thead>\n<tbody><tr>\n<td><code>OrgProfile</code></td>\n<td><code>/:org</code></td>\n<td>Pinned items and the public repository list</td>\n</tr>\n<tr>\n<td><code>RepoHome</code></td>\n<td><code>/:owner/:repo</code></td>\n<td>File table, latest commit, rendered README</td>\n</tr>\n<tr>\n<td><code>FileBlob</code></td>\n<td><code>/:owner/:repo/blob/:ref/**</code></td>\n<td>One file at a ref</td>\n</tr>\n<tr>\n<td><code>PullList</code></td>\n<td><code>/:owner/:repo/pulls</code></td>\n<td>Open pull requests — legacy frontend</td>\n</tr>\n<tr>\n<td><code>PullDetail</code></td>\n<td><code>/:owner/:repo/pull/:number</code></td>\n<td>Conversation, commits, checks, diff</td>\n</tr>\n<tr>\n<td><code>IssueList</code></td>\n<td><code>/:owner/:repo/issues</code></td>\n<td>Issues — React frontend</td>\n</tr>\n<tr>\n<td><code>Releases</code></td>\n<td><code>/:owner/:repo/releases</code></td>\n<td>Tagged releases, newest first</td>\n</tr>\n<tr>\n<td><code>NotFound</code></td>\n<td><code>/**</code></td>\n<td>404, served with a real 404 status</td>\n</tr>\n</tbody></table></div>\n<h3>Hazards</h3>\n<p><strong>Two frontends are in production at once, and the seam runs between two pages\nthat look identical.</strong> <code>/pulls</code> is served by the legacy frontend: rows are\n<code>.js-issue-row</code>, each carrying an <code>id</code> of <code>issue_&lt;number&gt;</code>. <code>/issues</code> is served\nby React: rows are <code>[data-testid=&quot;issue-pr-title-link&quot;]</code> inside\n<code>section[aria-label=&quot;All issues&quot;]</code>, and <code>.js-issue-row</code> matches nothing.\nSelectors written against either list return zero on the other, with no error.\nEstablish which frontend served a page before reading anything off it.</p>\n<p><strong>Half the ids and classes in the document are generated and change without\nnotice.</strong> Ids like <code>#_R_2qbd_</code> are React node ids and differ between renders of\nthe same page. Classes like <code>.Primer_Brand__Text-module__Text___XeGJJ</code> are CSS\nmodule hashes and change on every deploy.</p>\n<p><strong>The CSS module prefix is stable even though the hash is not.</strong> The\n<code>Primer_Brand__Text-module__Text___</code> part comes from the source module name and\nsurvives rebuilds, so <code>[class*=&quot;Primer_Brand__Text-module__Text___&quot;]</code> works\nwhere the full class does not. Use <code>class*=</code>, not <code>class^=</code> — <code>^=</code> matches the\nstart of the whole <code>class</code> attribute, so it quietly depends on that class being\nlisted first, which is not something the site guarantees.</p>\n<p><strong>Prefer the <code>aria-label</code>ed landmarks to everything else.</strong> <code>nav[aria-label=&quot;Global&quot;]</code>,\n<code>nav[aria-label=&quot;Repository&quot;]</code>, <code>nav[aria-label=&quot;Repository files&quot;]</code>,\n<code>nav[aria-label=&quot;Organization&quot;]</code>, <code>nav[aria-label=&quot;Pull request navigation tabs&quot;]</code>\nand <code>nav[aria-label=&quot;Pagination&quot;]</code> are written for assistive technology, are\nstable across both frontends, and are the only naming on the page that\ndescribes purpose rather than styling.</p>\n<p><strong><code>/:org</code> and <code>/:user</code> are the same URL shape.</strong> Nothing in the path says which\nyou are on. <code>nav[aria-label=&quot;Organization&quot;]</code> is present for an organization and\nabsent for a user.</p>\n<p><strong>The 404 page has no <code>h1</code>.</strong> Anything that treats &quot;no heading yet&quot; as &quot;still\nloading&quot; will wait forever on it. <code>img[alt*=&quot;404&quot;]</code> is the positive signal.</p>\n<p><strong><code>nav[aria-label=&quot;Repository files&quot;]</code> is on the repo root and not on a blob.</strong>\nThe sidebars look the same. Its absence is the cheapest test for which of the\ntwo you are on.</p>\n<h3>Method</h3>\n<p>Mapped signed-out with a real browser against <code>sightmap/sightmap</code>,\n<code>sightmap/atlas</code> and the <code>sightmap</code> organization page. Every selector in the\ncorpus was counted live on the view that declares it.</p>\n<p>Screenshots deliberately avoid pull request and issue conversation threads,\nwhich carry contributor names, avatars, and their writing.</p>\n"
  },
  {
    "slug": "ikea",
    "name": "IKEA",
    "site_url": "https://www.ikea.com/us/en/",
    "domains": [
      "ikea.com"
    ],
    "description": "US storefront — search, category browse, product detail, and the CMS-driven landing page, mapped signed-out.",
    "categories": [
      "commerce"
    ],
    "author": "chiplay",
    "created": "2026-08-06",
    "updated": "2026-08-08",
    "last_verified": "2026-08-08",
    "cli_version": "0.18.0",
    "spec_version": 1,
    "method": "browser",
    "auth": "none",
    "stats": {
      "views": 5,
      "components": 59,
      "requests": 11,
      "properties": 17,
      "memory": 61
    },
    "per_view": [
      {
        "name": "CategoryBrowse",
        "route": "/us/en/cat/:categorySlug",
        "components": 10,
        "requests": 1
      },
      {
        "name": "Home",
        "route": "/us/en",
        "components": 13,
        "requests": 1
      },
      {
        "name": "NotFound",
        "route": "/**",
        "components": 2,
        "requests": 0
      },
      {
        "name": "ProductDetail",
        "route": "/us/en/p/:productSlug",
        "components": 14,
        "requests": 4
      },
      {
        "name": "SearchResults",
        "route": "/us/en/search",
        "components": 11,
        "requests": 0
      }
    ],
    "screenshots": [
      "screenshots/01-search-results.webp",
      "screenshots/02-product-detail.webp"
    ],
    "files": [
      ".sightmap/category.yaml",
      ".sightmap/config.yaml",
      ".sightmap/home.yaml",
      ".sightmap/not-found.yaml",
      ".sightmap/product.yaml",
      ".sightmap/search.yaml",
      ".sightmap/shared.yaml"
    ],
    "commit": "18315720bf349f7a7a3f1b5fe4082469fcffebc6",
    "screenshotUrls": [
      "/atlas/screenshots/ikea/01-search-results.webp",
      "/atlas/screenshots/ikea/02-product-detail.webp"
    ],
    "bodyHtml": "<h2>IKEA</h2>\n<p>The US storefront (<code>/us/en/</code>), mapped as a signed-out shopper.</p>\n<h3>Coverage</h3>\n<div class=\"atlas-table-wrap\"><table class=\"atlas-table\">\n<thead>\n<tr>\n<th>View</th>\n<th>Route</th>\n<th>What it holds</th>\n</tr>\n</thead>\n<tbody><tr>\n<td><code>Home</code></td>\n<td><code>/us/en</code></td>\n<td>Category carousel and a stack of CMS-driven promo modules</td>\n</tr>\n<tr>\n<td><code>SearchResults</code></td>\n<td><code>/us/en/search</code></td>\n<td>Result summary, filter sidebar, product grid</td>\n</tr>\n<tr>\n<td><code>CategoryBrowse</code></td>\n<td><code>/us/en/cat/:categorySlug</code></td>\n<td>Page header, then either a subcategory carousel or the product grid</td>\n</tr>\n<tr>\n<td><code>ProductDetail</code></td>\n<td><code>/us/en/p/:productSlug</code></td>\n<td>Gallery, price, ratings, fulfillment, add to cart</td>\n</tr>\n<tr>\n<td><code>NotFound</code></td>\n<td><code>/**</code></td>\n<td>Catch-all page</td>\n</tr>\n</tbody></table></div>\n<p><code>GlobalHeader</code>, <code>Breadcrumbs</code>, <code>GlobalFooter</code>, <code>MainContent</code>, <code>CookieConsent</code>,\n<code>PreloadedModalHosts</code>, and <code>FeedbackPrompt</code> are global. All five views report\n<code>0 orphaned</code> coverage, with every selector <code>sel-probe</code>d at authoring and\nre-verified against the live site on 2026-08-08.</p>\n<p>Five views is the whole public shopping surface. Cart and checkout are excluded\ndeliberately (see Known gaps), and the remaining top-level paths (<code>/rooms/</code>,\n<code>/ideas/</code>, <code>/stores/</code>, <code>/offers/</code>) are editorial pages built from the same\n<code>hnf-</code> frame and the same CMS modules the home page uses, so mapping them would\nrepeat <code>Home</code> under different names rather than describe new structure.</p>\n<h3>Hazards</h3>\n<p><strong>Learn the four class prefixes and most selector guessing disappears.</strong> <code>hnf-</code>\nis the shared header, nav, and footer frame. <code>plp-</code> is the product list, shared\nby search and category pages. <code>pipf-</code> is the product page. <code>crec-</code> is the\nrecommendation fragment that loads late. A <code>plp-</code> class on a <code>/p/</code> URL means you\nare looking at a recommendation strip, not the product.</p>\n<p><strong>The <code>plp-</code> grid is only shared down to the card.</strong> <code>#product-list</code>,\n<code>[data-testid=&quot;plp-product-card&quot;]</code>, <code>[data-testid=&quot;plp-filter-side-bar&quot;]</code> and\n<code>.plp-price-module</code> behave the same on search and on a category. Inside the card\nthey do not: search renders <code>.plp-grid-product-card__*</code> and a category renders\n<code>.plp-mastercard__*</code>. A price selector written against a search result returns\nnothing on a category page and raises no error. Use <code>.plp-price-module</code>.</p>\n<p><strong>Half of <code>/cat/</code> has no products on it.</strong> The same route serves a hub, which\ncarries the subcategory carousel and nothing to buy, and a leaf, which carries\nthe grid and filters and no carousel. <code>/cat/tables-chairs-fu002/</code> is a hub;\n<code>/cat/desk-chairs-20654/</code> is a leaf. Nothing in the URL distinguishes them —\ntest for <code>#product-list</code> before concluding a category is empty.</p>\n<p><strong>A category id you got wrong sends you to the entire catalog.</strong> The slug is\ndecorative: <code>/cat/totally-made-up-fu002/</code> loads Tables &amp; Chairs and rewrites the\npath. But a bad <em>id</em> does not 404 either. <code>/cat/tables-chairs-zz999/</code> redirects\nto <code>/cat/products-products/</code>, the root of the catalog, so a typo silently widens\na narrow query to everything IKEA sells. Read <code>.hnf-pageheader__h1</code> to find out\nwhere you actually are.</p>\n<p><strong>Five closed modals ship on every page.</strong> Separate hosts from five different\nfrontends (<code>hnf-</code>, <code>wlo-modal-</code>, <code>rec-</code>, <code>ugc-rr-pip-fe-</code>, <code>rr-leave-review-</code>)\nare all rendered before anything opens them, each carrying a <code>--close</code> modifier\nand each with a paired <code>__backdrop</code>. Counting <code>[role=dialog]</code> or asking &quot;is a\nmodal open&quot; gives the wrong answer. Test for the absence of <code>--close</code>.</p>\n<p><strong>The home page&#39;s module testids are CMS ids.</strong> Each promo module carries an\nouter <code>data-testid</code> that is a Contentful entry id\n(<code>data-testid=&quot;5EPhOkZOk1TdhhrR5us7Yt&quot;</code>) and an inner one that names the\ncomponent type (<code>hri-bento-container</code>, <code>hri-deals</code>, <code>hri-editorial-shelf</code>). Only\nthe inner one survives a marketing edit.</p>\n<p><strong>Card counts are page sizes, not result counts.</strong> The grid renders about 22\ncards and appends on scroll. <code>.search-summary</code> carries the real total.</p>\n<p><strong>Product names keep their diacritics.</strong> GÖRSNYGG, PÄRKLA. Matching on an\nASCII-typed name fails.</p>\n<p><strong>The article number is in the URL and in the API calls.</strong> The digits ending a\nproduct slug (<code>...-40504193/</code>) are the article number that\n<code>web-api.ikea.com/circular/...</code> and the 3D model endpoint both key on, so API\ncalls are derivable from the URL with no lookup step.</p>\n<h3>Known gaps</h3>\n<p>Cart and checkout stop at the add-to-cart control. Going further means putting\nitems into a real basket on a live storefront.</p>\n<p>The store picker inside <code>FulfillmentSection</code> changes what the page reports for\ndelivery and in-store stock. It was left on the IP-inferred default rather than\ndriven, so availability text in this map reflects one location.</p>\n<p>Search embeds a dormant Cloudflare Turnstile widget (<code>cf-turnstile-response</code>).\nIt never challenged during this mapping, but it makes search the route most\nlikely to start gating automated traffic, and this map would go stale there\nfirst.</p>\n<p>Only the <code>/us/en/</code> storefront is mapped. The locale prefix is part of the path,\nso other markets have their own prices, availability, and category ids.</p>\n<h3>Screenshots</h3>\n<p>Signed-out views of public catalog pages. The utility bar and fulfillment panel\nname a nearby store and ZIP inferred from the capture machine&#39;s IP address — a\ngeolocated store default, not anything a visitor entered.</p>\n"
  },
  {
    "slug": "nike",
    "name": "Nike",
    "site_url": "https://www.nike.com/",
    "domains": [
      "nike.com"
    ],
    "description": "US storefront — the shared product wall behind both search and category browse, product pages, and a merchandising 404.",
    "categories": [
      "commerce"
    ],
    "author": "chiplay",
    "created": "2026-08-06",
    "updated": "2026-08-08",
    "last_verified": "2026-08-08",
    "cli_version": "0.18.0",
    "spec_version": 1,
    "method": "browser",
    "auth": "none",
    "stats": {
      "views": 5,
      "components": 42,
      "requests": 17,
      "properties": 14,
      "memory": 41
    },
    "per_view": [
      {
        "name": "CategoryWall",
        "route": "/w/:categorySlug",
        "components": 12,
        "requests": 2
      },
      {
        "name": "Home",
        "route": "/",
        "components": 4,
        "requests": 1
      },
      {
        "name": "NotFound",
        "route": "/**",
        "components": 3,
        "requests": 0
      },
      {
        "name": "ProductDetail",
        "route": "/t/:productSlug/:styleCode",
        "components": 13,
        "requests": 6
      },
      {
        "name": "SearchResults",
        "route": "/w",
        "components": 12,
        "requests": 1
      }
    ],
    "screenshots": [
      "screenshots/01-product-wall.webp",
      "screenshots/02-product-detail.webp"
    ],
    "files": [
      ".sightmap/category.yaml",
      ".sightmap/config.yaml",
      ".sightmap/home.yaml",
      ".sightmap/not-found.yaml",
      ".sightmap/product.yaml",
      ".sightmap/shared.yaml",
      ".sightmap/wall.yaml"
    ],
    "commit": "18315720bf349f7a7a3f1b5fe4082469fcffebc6",
    "screenshotUrls": [
      "/atlas/screenshots/nike/01-product-wall.webp",
      "/atlas/screenshots/nike/02-product-detail.webp"
    ],
    "bodyHtml": "<h2>Nike</h2>\n<p>The US storefront, mapped as a signed-out shopper.</p>\n<h3>Coverage</h3>\n<div class=\"atlas-table-wrap\"><table class=\"atlas-table\">\n<thead>\n<tr>\n<th>View</th>\n<th>Route</th>\n<th>What it holds</th>\n</tr>\n</thead>\n<tbody><tr>\n<td><code>Home</code></td>\n<td><code>/</code></td>\n<td>Editorial campaign cards and product carousels</td>\n</tr>\n<tr>\n<td><code>SearchResults</code></td>\n<td><code>/w</code></td>\n<td>Product wall — filter rail, result grid</td>\n</tr>\n<tr>\n<td><code>CategoryWall</code></td>\n<td><code>/w/:categorySlug</code></td>\n<td>The same wall, addressed by category</td>\n</tr>\n<tr>\n<td><code>ProductDetail</code></td>\n<td><code>/t/:productSlug/:styleCode</code></td>\n<td>Carousel, price, size grid, add to bag</td>\n</tr>\n<tr>\n<td><code>NotFound</code></td>\n<td><code>/**</code></td>\n<td>Apology line above a product carousel</td>\n</tr>\n</tbody></table></div>\n<p><code>GlobalNav</code>, <code>NavScrim</code>, <code>ContentWrapper</code>, <code>ModalRoot</code>, <code>RouteAnnouncer</code>,\n<code>EmbeddedMessaging</code>, and <code>GlobalFooter</code> are global. <code>PromoBanner</code> renders on\n<code>ProductDetail</code> only. All five views report <code>0 orphaned</code> coverage, with every\nselector <code>sel-probe</code>d live against all five view URLs on 2026-08-08.</p>\n<h3>Hazards</h3>\n<p><strong>Search and category browse are the same page.</strong> <code>/w?q=&lt;terms&gt;</code> and\n<code>/w/&lt;categorySlug&gt;</code> both render <code>#Wall</code> with the same <code>.product-card</code> grid and\nthe same filter rail. They are mapped as two views because the routes differ, but\none set of selectors drives both. The category slug ends in an opaque taxonomy\ncode (<code>37v7jznik1zy7ok</code>) that cannot be constructed from a name — follow a link\nfrom the shopping menu.</p>\n<p><strong>A discontinued product returns 200, not 404.</strong> The page renders <code>pdp-main</code> and\nshows &quot;THE PRODUCT YOU ARE LOOKING FOR IS NO LONGER AVAILABLE&quot; above a\nrecommendations carousel. Nothing structural separates it from a live product.\nCheck for <code>#pdp_product_title</code> and a size grid; both vanish when the product is\ngone.</p>\n<p><strong>The 404 sells things.</strong> It is rendered by the same CMS app as the home page —\nboth mount <code>#ciclp-app</code> — and carries a carousel of real products at real prices.\nAn agent scraping &quot;products on this page&quot; gets a non-empty answer from a page\nthat found nothing. The title is the signal.</p>\n<p><strong>Two test-hook attributes, and they are not interchangeable.</strong> <code>data-testid</code>\ncovers the nav, footer, and product page; <code>data-test</code> appears on the browse shell\n(<code>[data-test=&quot;browseShell&quot;]</code>). Casing is inconsistent within a page too:\n<code>pdp-main</code> and <code>atb-button</code> sit alongside <code>ImageCarousel</code> and <code>Thumbnail-0</code>.</p>\n<p><strong>Ids that are not addressable.</strong> React <code>useId</code> emits <code>#:r0:</code>, which changes per\nrender and is not a valid CSS identifier unescaped. Feature modules\n(privacy consent, chat, AI search, error modal) each mount into a div whose id is\na random UUID, with the module&#39;s name appearing only on the paired\n<code>#&lt;name&gt;-module-script-&lt;uuid&gt;</code> tag.</p>\n<p><strong>Sold-out sizes stay in the grid.</strong> Presence in <code>[data-testid=&quot;pdp-grid-selector-item&quot;]</code>\nis not availability.</p>\n<h3>Lint</h3>\n<p><code>sightmap lint</code> passes with no warnings, but one selector is written oddly and\nthe reason should be on the record. <code>EmbeddedMessaging</code> uses\n<code>[id=&quot;embedded-messaging&quot;]</code> rather than <code>#embedded-messaging</code>. The two match the\nsame single element both live and offline; the hash form trips the\n<code>id-hash-selector</code> rule, which reads this as an auto-generated id. It is not —\nit is the fixed container Salesforce&#39;s messaging widget mounts into, stable on\nevery route and every load observed here. The ids on this site that genuinely\nare generated are the UUID module mounts described above, and nothing in this\ncorpus selects on them.</p>\n<h3>Known gaps</h3>\n<p>Cart and checkout stop at the add-to-bag control.</p>\n<p>Nike Members surfaces and anything behind Sign In are out of scope per\n<a href=\"../../docs/POLICY.md\">docs/POLICY.md</a>.</p>\n<p><code>ProductDetail</code> is pinned to one colorway. The style code ending the URL is the\ncolorway rather than the product, so a different color of the same shoe is a\ndifferent URL with the same slug. The page structure holds across both.</p>\n<p>The wall renders 24 cards and appends on scroll. Only the first batch was mapped,\nwhich is enough since every card is the same component.</p>\n<h3>Screenshots</h3>\n<p>Signed-out views of public catalog pages.</p>\n"
  },
  {
    "slug": "uniqlo",
    "name": "UNIQLO",
    "site_url": "https://www.uniqlo.com/us/en/",
    "domains": [
      "uniqlo.com"
    ],
    "description": "US storefront — category listings, product pages, search, and an error page with a real address.",
    "categories": [
      "commerce"
    ],
    "author": "chiplay",
    "created": "2026-08-07",
    "updated": "2026-08-08",
    "last_verified": "2026-08-08",
    "cli_version": "0.18.0",
    "spec_version": 1,
    "method": "browser",
    "auth": "none",
    "stats": {
      "views": 5,
      "components": 30,
      "requests": 17,
      "properties": 11,
      "memory": 29
    },
    "per_view": [
      {
        "name": "CategoryListing",
        "route": "/us/en/:gender/:category",
        "components": 6,
        "requests": 1
      },
      {
        "name": "Home",
        "route": "/us/en/:gender",
        "components": 3,
        "requests": 1
      },
      {
        "name": "NotFound",
        "route": "/us/en/not-found",
        "components": 1,
        "requests": 0
      },
      {
        "name": "ProductDetail",
        "route": "/us/en/products/:productId/:colorCode",
        "components": 3,
        "requests": 8
      },
      {
        "name": "SearchResults",
        "route": "/us/en/search",
        "components": 5,
        "requests": 2
      }
    ],
    "screenshots": [
      "screenshots/01-category-listing.webp",
      "screenshots/02-product-detail.webp"
    ],
    "files": [
      ".sightmap/category.yaml",
      ".sightmap/config.yaml",
      ".sightmap/gender-home.yaml",
      ".sightmap/not-found.yaml",
      ".sightmap/product.yaml",
      ".sightmap/search.yaml",
      ".sightmap/shared.yaml"
    ],
    "commit": "18315720bf349f7a7a3f1b5fe4082469fcffebc6",
    "screenshotUrls": [
      "/atlas/screenshots/uniqlo/01-category-listing.webp",
      "/atlas/screenshots/uniqlo/02-product-detail.webp"
    ],
    "bodyHtml": "<h2>UNIQLO</h2>\n<p>The US storefront (<code>/us/en/</code>), mapped as a signed-out shopper.</p>\n<h3>Coverage</h3>\n<div class=\"atlas-table-wrap\"><table class=\"atlas-table\">\n<thead>\n<tr>\n<th>View</th>\n<th>Route</th>\n<th>What it holds</th>\n</tr>\n</thead>\n<tbody><tr>\n<td><code>Home</code></td>\n<td><code>/us/en/:gender</code></td>\n<td>Media banners and a category grid</td>\n</tr>\n<tr>\n<td><code>SearchResults</code></td>\n<td><code>/us/en/search</code></td>\n<td>Product tile grid</td>\n</tr>\n<tr>\n<td><code>CategoryListing</code></td>\n<td><code>/us/en/:gender/:category</code></td>\n<td>Sticky subcategory tabs above the grid</td>\n</tr>\n<tr>\n<td><code>ProductDetail</code></td>\n<td><code>/us/en/products/:productId/:colorCode</code></td>\n<td>Gallery, options, size table, related products</td>\n</tr>\n<tr>\n<td><code>NotFound</code></td>\n<td><code>/us/en/not-found</code></td>\n<td>Error page, reached by redirect</td>\n</tr>\n</tbody></table></div>\n<p><code>PromoStrip</code>, <code>NavigationHeader</code>, <code>PageContent</code>, <code>Breadcrumbs</code>,\n<code>PreloadedDialog</code>, <code>BackToFrontOverlay</code>, <code>Accordion</code>, <code>PromoModal</code>,\n<code>ContentAlignment</code>, <code>ECGrid</code>, <code>Drawer</code>, <code>PopupFormDialog</code>, <code>AppShell</code>, and\n<code>GlobalFooter</code> are global. All five views report <code>0 orphaned</code> coverage, with\nevery selector <code>sel-probe</code>d at authoring and re-verified against the live site\non 2026-08-08.</p>\n<h3>Reliable signals</h3>\n<p><strong>The page type is a class on the content root.</strong> <code>.fr-ec-template-plp</code> is a\ncategory listing, <code>.fr-ec-template-pdp</code> is a product page, <code>.home-template</code> is\nthe landing page. An agent can branch on this instead of parsing a URL.</p>\n<p><strong>The error page has a real address.</strong> An unmatched path redirects to\n<code>/us/en/not-found</code>, so <code>location.pathname</code> answers &quot;did I land on an error page&quot;\nwith no DOM inspection.</p>\n<h3>Hazards</h3>\n<p><strong>The <code>data-testid</code> values are design-system primitives, not identifiers.</strong>\n<code>ITOTypography</code> matched 574 elements on one page, <code>ITOImage</code> 363, <code>ITOLink</code> 128.\nThey tell you an element is <em>a</em> piece of text and never <em>which</em> one. Use the\n<code>fr-ec-</code> classes for identity and read <code>ITO*</code> as type information.</p>\n<p><strong>The landing page has three addresses and state decides which you get.</strong>\n<code>/us/en/</code> redirects to whichever gender was browsed last, <code>/us/en/men</code> keeps its\npath, and <code>/us/en/women</code> normalizes to <code>/us/en/</code>. The preference is stored\nclient-side, so two agents at the same URL land on different pages. This map\nanchors on <code>/us/en/:gender</code> because that is where a warm profile actually ends\nup.</p>\n<p><strong>The navigation renders three times.</strong> Desktop, mobile, and sticky variants all\nsit in the DOM, so any count of nav links is tripled.</p>\n<p><strong>Three empty overlay hosts ship on a browse route.</strong> <code>ITODialog</code>,\n<code>.b2f-overlay</code>, and the POPUP Form dialog are all present and empty before\nanything opens them, so counting dialogs overstates what is actually showing.</p>\n<p><strong>Breadcrumbs are at the bottom.</strong> <code>[data-testid=&quot;ITOBreadcrumbGroup&quot;]</code> sits at\nthe foot of the page, not above the content.</p>\n<p><strong>A product URL grows after loading.</strong> Requesting\n<code>/us/en/products/:productId/:colorCode</code> appends <code>?colorDisplayCode=</code> and\n<code>?sizeDisplayCode=</code> for the default variant, so the URL after load differs from\nthe one requested even on success.</p>\n<h3>Known gaps</h3>\n<p>Cart, wishlist, and checkout are out of scope; the map stops at the product\noptions.</p>\n<p>Accounts and anything behind My Account are out of scope per\n<a href=\"../../docs/POLICY.md\">docs/POLICY.md</a>.</p>\n<p><code>ProductDetail</code> is pinned to one colourway, since colour is a path segment rather\nthan a parameter.</p>\n<p>Only the <code>/us/en/</code> storefront is mapped. The locale prefix is part of the path,\nso other markets have their own catalogue and prices.</p>\n<h3>Screenshots</h3>\n<p>Signed-out views of public catalog pages.</p>\n"
  },
  {
    "slug": "vuori",
    "name": "Vuori",
    "site_url": "https://vuoriclothing.com/",
    "domains": [
      "vuoriclothing.com"
    ],
    "description": "Shopify storefront on Next.js — collections, product pages, search, and a 404 with an empty document title.",
    "categories": [
      "commerce"
    ],
    "author": "chiplay",
    "created": "2026-08-06",
    "updated": "2026-08-08",
    "last_verified": "2026-08-06",
    "cli_version": "0.18.0",
    "spec_version": 1,
    "method": "browser",
    "auth": "none",
    "stats": {
      "views": 5,
      "components": 47,
      "requests": 14,
      "properties": 18,
      "memory": 54
    },
    "per_view": [
      {
        "name": "Collection",
        "route": "/collections/:handle",
        "components": 10,
        "requests": 1
      },
      {
        "name": "Home",
        "route": "/",
        "components": 7,
        "requests": 0
      },
      {
        "name": "NotFound",
        "route": "/**",
        "components": 1,
        "requests": 0
      },
      {
        "name": "ProductDetail",
        "route": "/products/:handle",
        "components": 10,
        "requests": 1
      },
      {
        "name": "SearchResults",
        "route": "/search",
        "components": 5,
        "requests": 1
      }
    ],
    "screenshots": [
      "screenshots/01-collection.webp",
      "screenshots/02-product-detail.webp"
    ],
    "files": [
      ".sightmap/collection.yaml",
      ".sightmap/config.yaml",
      ".sightmap/home.yaml",
      ".sightmap/not-found.yaml",
      ".sightmap/product.yaml",
      ".sightmap/search.yaml",
      ".sightmap/shared.yaml"
    ],
    "commit": "18315720bf349f7a7a3f1b5fe4082469fcffebc6",
    "screenshotUrls": [
      "/atlas/screenshots/vuori/01-collection.webp",
      "/atlas/screenshots/vuori/02-product-detail.webp"
    ],
    "bodyHtml": "<h2>Vuori</h2>\n<p>A direct-to-consumer apparel storefront, mapped as a signed-out shopper: Shopify\nbehind a Next.js front end with MUI components.</p>\n<h3>Coverage</h3>\n<div class=\"atlas-table-wrap\"><table class=\"atlas-table\">\n<thead>\n<tr>\n<th>View</th>\n<th>Route</th>\n<th>What it holds</th>\n</tr>\n</thead>\n<tbody><tr>\n<td><code>Home</code></td>\n<td><code>/</code></td>\n<td>Hero carousel, featured products, tabbed category carousel</td>\n</tr>\n<tr>\n<td><code>Collection</code></td>\n<td><code>/collections/:handle</code></td>\n<td>Headline, subcategory carousel, filter bar, product grid</td>\n</tr>\n<tr>\n<td><code>ProductDetail</code></td>\n<td><code>/products/:handle</code></td>\n<td>Media grid, title and price, options, spec accordions</td>\n</tr>\n<tr>\n<td><code>SearchResults</code></td>\n<td><code>/search</code></td>\n<td>The same filter bar and grid as a collection</td>\n</tr>\n<tr>\n<td><code>NotFound</code></td>\n<td><code>/**</code></td>\n<td>Apology heading, empty title</td>\n</tr>\n</tbody></table></div>\n<p><code>PromoBanner</code>, <code>DesktopHeader</code>, <code>MobileDrawer</code>, <code>MainContent</code>, <code>Breadcrumbs</code>,\n<code>SkipNavigation</code>, <code>RouteAnnouncer</code>, <code>CookieConsent</code>, <code>NewsletterOverlay</code>,\n<code>GlobalFooter</code>, <code>FeedbackWidget</code>, and <code>BuildStamp</code> are global. All five views\nreport <code>0 orphaned</code> coverage, with every selector <code>sel-probe</code>d on 2026-08-06.</p>\n<h3>Hazards</h3>\n<p><strong>The 404 has an empty document title.</strong> <code>document.title</code> is <code>&quot;&quot;</code>. Any agent\nthat identifies pages by title gets nothing, and code branching on a title\ncontaining &quot;404&quot; or &quot;not found&quot; never fires. The only text signal is the h1,\n&quot;The page you&#39;re looking for cannot be found&quot;, which also avoids the number. An\nunknown collection handle lands here too rather than redirecting.</p>\n<p><strong>Some <code>data-testid</code> values are content, and one kind is unusable.</strong> Carousel\nslides are labelled with the product name and colourway\n(<code>data-testid=&#39;Seaside Short 8&quot; | Nautical&#39;</code>) and category cards with the\ncategory label (<code>data-testid=&quot;Athletic Shorts&quot;</code>). They change whenever\nmerchandising does, and the product ones contain a double quote for the inch\nmark, so they cannot be written as a CSS attribute selector without escaping.\nTreat any testid that reads like a sentence as data.</p>\n<p><strong>The skip-navigation link is broken.</strong> Its href resolves to\n<code>/products/meta-pant-oxblood.json#main-content</code> rather than to <code>#main-content</code> on\nthe current page, so following it navigates to an unrelated product&#39;s JSON\nendpoint. Present on every route, including the 404.</p>\n<p><strong>The page prints its own render time.</strong> <code>#buildTime</code> holds a timestamp that\nchanged on every load observed, which makes it a per-request server-render time\nrather than a build stamp — a direct read on whether a response was cached or\nfreshly generated.</p>\n<p><strong>The product card is the anchor.</strong> There is no inner link to descend into; the\nhref is on <code>[data-testid=&quot;productCard&quot;]</code> itself. Card text runs badge, name, and\nprice together with no separator.</p>\n<p><strong>Collection handles resolve loosely.</strong> <code>/collections/mens-shorts</code> serves\n<code>/collections/shorts</code> and rewrites the path, so read\n<code>[data-testid=&quot;plp-headline-container&quot;]</code> rather than trusting the URL.</p>\n<p><strong>The mobile drawer renders on desktop.</strong> It ships closed at full viewport size\nand contains its own copy of the whole navigation, so menu links match twice on\nevery route.</p>\n<h3>Known gaps</h3>\n<p>Cart and checkout stop at the product options. Going further means adding items\nto a real cart on a live storefront.</p>\n<p>Accounts, order status, and anything behind Sign In are out of scope per\n<a href=\"../../docs/POLICY.md\">docs/POLICY.md</a>.</p>\n<p><code>MediaGrid</code> uses <code>#media-grid-desktop</code>, a desktop-only id. The mobile gallery is\na separate element, so this corpus describes the desktop viewport. Everything\nelse mapped here is viewport-independent.</p>\n<p><code>ProductDetail</code> is pinned to one colourway, since the handle encodes colour and\neach colour is its own URL.</p>\n<h3>Screenshots</h3>\n<p>Signed-out views of public catalog pages.</p>\n"
  }
]

export const atlasCategories: string[] = ["commerce","devtools","media","saas","social","travel"]
